import { Box, Divider, Skeleton, useTheme } from "@mui/material"

export const SkeletonDirectionOverviewSidebar = () => {
  const theme = useTheme()
  const {
    root,
    headerWrapper,
    locationAvatar,
    locationText,
    durationText,
    distanceText,
    travelInfoText,
    contentWrapper,
    qrCodeContainer,
    qrCode,
    qrcodeText,
    stepContainer,
    stepListContainer,
    actionContainer,
    startButton,
    divider,
    avoidStepButton,
    durationContainer,
  } = theme.components[`SkeletonDirectionOverviewSidebar`]?.styleOverrides || {}

  return (
    <Box sx={root}>
      <Box sx={headerWrapper}>
        <Skeleton sx={locationAvatar} variant="rectangular" />
        <Skeleton sx={locationText} variant="text" />
        <Box sx={qrCodeContainer}>
          <Skeleton sx={qrCode} variant="rounded" />
          <Skeleton sx={qrcodeText} variant="text" />
        </Box>
      </Box>
      <Box sx={contentWrapper}>
        <Box sx={durationContainer}>
          <Skeleton sx={durationText} variant="text" />
          <Skeleton sx={avoidStepButton} variant="rounded" />
        </Box>
        <Skeleton sx={distanceText} variant="text" />
        <Divider sx={divider} />
        <Skeleton sx={travelInfoText} variant="text" />
      </Box>
      <Box sx={stepContainer}>
        <Skeleton sx={stepListContainer} variant="rounded" />
      </Box>
      <Box sx={actionContainer}>
        <Skeleton sx={startButton} variant="rounded" />
      </Box>
    </Box>
  )
}
